import React from 'react';
import logoImg from '../assets/logo.png';

export default function ForgotPassword({ setAuthView }) {
  const onSubmit = (e) => {
    e.preventDefault();
    alert("Password reset link sent to your email!");
    setAuthView('login');
  };

  return (
    <div className="auth-card">
      <div className="auth-header">
        <img src={logoImg} alt="Logo" />
        <h2>Reset Password</h2>
        <p>Enter your email to receive a reset link</p>
      </div>
      <form onSubmit={onSubmit} style={{ overflow: 'visible' }}>
        <div className="form-group full-width">
          <label>Email Address</label>
          <input type="email" required placeholder="admin@swimmersacademy.com" />
        </div>
        <button type="submit" className="submit-btn" style={{ marginTop: '25px', width: '100%' }}>
          <i className="fas fa-envelope"></i> Send Reset Link
        </button>
      </form>
      <div className="auth-links" style={{ justifyContent: 'center' }}>
        <span onClick={() => setAuthView('login')}><i className="fas fa-arrow-left"></i> Back to Login</span>
      </div>
    </div>
  );
}